export const TOOLBAR_HEIGHT = 58;
